import { Component } from '@angular/core'
import { AtomModule } from '../../atom/atom.module';

@Component({
  selector: 'app-game-ad-alpha',
  templateUrl: './game-ad-alpha.component.html',
  styleUrls: ['./game-ad-alpha.component.less'],
  standalone: true,
  imports: [
    AtomModule,
    
  ]
})
export class GameAdAlphaComponent {}
